import { render } from "./WebsiteFooter.vue?vue&type=template&id=294a9c1b&scoped=true"
import script from "./WebsiteFooter.vue?vue&type=script&lang=js"
export * from "./WebsiteFooter.vue?vue&type=script&lang=js"

import "./WebsiteFooter.vue?vue&type=style&index=0&id=294a9c1b&scoped=true&lang=css"

import exportComponent from "G:\\vue\\lycbuild\\code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294a9c1b"]])

export default __exports__